import { render, staticRenderFns } from "./ISALanguageSelector.vue?vue&type=template&id=def16912&scoped=true&"
import script from "./ISALanguageSelector.vue?vue&type=script&lang=js&"
export * from "./ISALanguageSelector.vue?vue&type=script&lang=js&"
import style0 from "./ISALanguageSelector.vue?vue&type=style&index=0&id=def16912&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def16912",
  null
  
)

export default component.exports